/**
 *
 * IMEI Check
 *
 */
import React, { memo } from "react";
import { BringYourPhone } from "./components/bring-your-phone";
import { CompatibiltyInfo } from "./components/compatibilty-info";
import { CommonQuestions } from "./components/common-questions";
import { Footer } from "app/components/AdminLayout/Footer";

interface Props {}

export const IMEICheck = memo((props: Props) => {
  return (
    <React.Fragment>
      <main className="overflow-hidden">
        {/* Bring Your Phone to VLE Mobile Section */}
        <BringYourPhone />
        {/* Compatibilty Info Section */}
        <CompatibiltyInfo />
        {/* Common Questions Section */}
        <CommonQuestions />
      </main>
      <Footer />
    </React.Fragment>
  );
});
